import { render } from "./introduceRight.vue?vue&type=template&id=13c4ec20&scoped=true"
import script from "./introduceRight.vue?vue&type=script&lang=js"
export * from "./introduceRight.vue?vue&type=script&lang=js"

import "./introduceRight.vue?vue&type=style&index=0&id=13c4ec20&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c4ec20"]])

export default __exports__